import { render, staticRenderFns } from "./CodeEditorHTML.vue?vue&type=template&id=5790c482&scoped=true"
import script from "./CodeEditorHTML.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeEditorHTML.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CodeEditorHTML.vue?vue&type=style&index=0&id=5790c482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5790c482",
  null
  
)

export default component.exports